// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import ScrollToTop from './components/ScrollToTop'; // Add this import

import HomePage from './pages/HomePage';
import WhatWeDoPage from './pages/WhatWeDoPage';
import PeopleCareerPage from './pages/PeopleCareerPage';
import ContactUs from './pages/ContactUs';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add this line */}
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/what-we-do" element={<WhatWeDoPage />} />
          <Route path="/people-career" element={<PeopleCareerPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;